var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMultilingualMachineV3TranslatableContent from '@wix/ambassador-multilingual-machine-v3-translatable-content/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Format;
(function (Format) {
    /** Unspecified format. Is automatically rejected. */
    Format["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    /** Plain text content. */
    Format["PLAIN_TEXT"] = "PLAIN_TEXT";
    /** HTML content. */
    Format["HTML"] = "HTML";
    /** Rich Content. */
    Format["RICH"] = "RICH";
})(Format || (Format = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var Type;
(function (Type) {
    /** Regular link button */
    Type["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    Type["ACTION"] = "ACTION";
})(Type || (Type = {}));
export var Target;
(function (Target) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    Target["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    Target["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    Target["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    Target["TOP"] = "TOP";
})(Target || (Target = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var SupportedLanguage;
(function (SupportedLanguage) {
    /** Undefined Language */
    SupportedLanguage["UNDEFINED_SUPPORTED_LANGUAGE"] = "UNDEFINED_SUPPORTED_LANGUAGE";
    /** Afrikaans */
    SupportedLanguage["AF"] = "AF";
    /** Albanian */
    SupportedLanguage["SQ"] = "SQ";
    /** Amharic */
    SupportedLanguage["AM"] = "AM";
    /** Arabic */
    SupportedLanguage["AR"] = "AR";
    /** Armenian */
    SupportedLanguage["HY"] = "HY";
    /** Assamese */
    SupportedLanguage["AS"] = "AS";
    /** Aymara */
    SupportedLanguage["AY"] = "AY";
    /** Azerbaijani */
    SupportedLanguage["AZ"] = "AZ";
    /** Bambara */
    SupportedLanguage["BM"] = "BM";
    /** Basque */
    SupportedLanguage["EU"] = "EU";
    /** Belarusian */
    SupportedLanguage["BE"] = "BE";
    /** Bengali */
    SupportedLanguage["BN"] = "BN";
    /** Bhojpuri */
    SupportedLanguage["BHO"] = "BHO";
    /** Bosnian */
    SupportedLanguage["BS"] = "BS";
    /** Bulgarian */
    SupportedLanguage["BG"] = "BG";
    /** Catalan */
    SupportedLanguage["CA"] = "CA";
    /** Cebuano */
    SupportedLanguage["CEB"] = "CEB";
    /** Chinese (Simplified) */
    SupportedLanguage["ZH_CN"] = "ZH_CN";
    /** Chinese (Traditional) */
    SupportedLanguage["ZH_TW"] = "ZH_TW";
    /** Chinese (Simplified) */
    SupportedLanguage["ZH"] = "ZH";
    /** Corsican */
    SupportedLanguage["CO"] = "CO";
    /** Croatian */
    SupportedLanguage["HR"] = "HR";
    /** Czech */
    SupportedLanguage["CS"] = "CS";
    /** Danish */
    SupportedLanguage["DA"] = "DA";
    /** Dhivehi */
    SupportedLanguage["DV"] = "DV";
    /** Dogri */
    SupportedLanguage["DOI"] = "DOI";
    /** Dutch */
    SupportedLanguage["NL"] = "NL";
    /** English */
    SupportedLanguage["EN"] = "EN";
    /** Esperanto */
    SupportedLanguage["EO"] = "EO";
    /** Estonian */
    SupportedLanguage["ET"] = "ET";
    /** Ewe */
    SupportedLanguage["EE"] = "EE";
    /** Filipino (Tagalog) */
    SupportedLanguage["FIL"] = "FIL";
    /** Finnish */
    SupportedLanguage["FI"] = "FI";
    /** French */
    SupportedLanguage["FR"] = "FR";
    /** Frisian */
    SupportedLanguage["FY"] = "FY";
    /** Galician */
    SupportedLanguage["GL"] = "GL";
    /** Georgian */
    SupportedLanguage["KA"] = "KA";
    /** German */
    SupportedLanguage["DE"] = "DE";
    /** Greek */
    SupportedLanguage["EL"] = "EL";
    /** Guarani */
    SupportedLanguage["GN"] = "GN";
    /** Gujarati */
    SupportedLanguage["GU"] = "GU";
    /** Haitian Creole */
    SupportedLanguage["HT"] = "HT";
    /** Hausa */
    SupportedLanguage["HA"] = "HA";
    /** Hawaiian */
    SupportedLanguage["HAW"] = "HAW";
    /** Hebrew */
    SupportedLanguage["HE"] = "HE";
    /** Hindi */
    SupportedLanguage["HI"] = "HI";
    /** Hmong */
    SupportedLanguage["HMN"] = "HMN";
    /** Hungarian */
    SupportedLanguage["HU"] = "HU";
    /** Icelandic */
    SupportedLanguage["IS"] = "IS";
    /** Igbo */
    SupportedLanguage["IG"] = "IG";
    /** Ilocano */
    SupportedLanguage["ILO"] = "ILO";
    /** Indonesian */
    SupportedLanguage["ID"] = "ID";
    /** Irish */
    SupportedLanguage["GA"] = "GA";
    /** Italian */
    SupportedLanguage["IT"] = "IT";
    /** Japanese */
    SupportedLanguage["JA"] = "JA";
    /** Javanese */
    SupportedLanguage["JW"] = "JW";
    /** Kannada */
    SupportedLanguage["KN"] = "KN";
    /** Kazakh */
    SupportedLanguage["KK"] = "KK";
    /** Khmer */
    SupportedLanguage["KM"] = "KM";
    /** Kinyarwanda */
    SupportedLanguage["RW"] = "RW";
    /** Konkani */
    SupportedLanguage["GOM"] = "GOM";
    /** Korean */
    SupportedLanguage["KO"] = "KO";
    /** Krio */
    SupportedLanguage["KRI"] = "KRI";
    /** Kurdish */
    SupportedLanguage["KU"] = "KU";
    /** Kurdish (Sorani) */
    SupportedLanguage["CKB"] = "CKB";
    /** Kyrgyz */
    SupportedLanguage["KY"] = "KY";
    /** Lao */
    SupportedLanguage["LO"] = "LO";
    /** Latin */
    SupportedLanguage["LA"] = "LA";
    /** Latvian */
    SupportedLanguage["LV"] = "LV";
    /** Lingala */
    SupportedLanguage["LN"] = "LN";
    /** Lithuanian */
    SupportedLanguage["LT"] = "LT";
    /** Luganda */
    SupportedLanguage["LG"] = "LG";
    /** Luxembourgish */
    SupportedLanguage["LB"] = "LB";
    /** Macedonian */
    SupportedLanguage["MK"] = "MK";
    /** Maithili */
    SupportedLanguage["MAI"] = "MAI";
    /** Malagasy */
    SupportedLanguage["MG"] = "MG";
    /** Malay */
    SupportedLanguage["MS"] = "MS";
    /** Malayalam */
    SupportedLanguage["ML"] = "ML";
    /** Maltese */
    SupportedLanguage["MT"] = "MT";
    /** Maori */
    SupportedLanguage["MI"] = "MI";
    /** Marathi */
    SupportedLanguage["MR"] = "MR";
    /** Mriteilon (Manipuri) */
    SupportedLanguage["MNI_MTEI"] = "MNI_MTEI";
    /** Mizo */
    SupportedLanguage["LUS"] = "LUS";
    /** Mongolian */
    SupportedLanguage["MN"] = "MN";
    /** Myanmar (Burmese) */
    SupportedLanguage["MY"] = "MY";
    /** Nepali */
    SupportedLanguage["NE"] = "NE";
    /** Norwegian */
    SupportedLanguage["NO"] = "NO";
    /** Nyanja (Chichewa) */
    SupportedLanguage["NY"] = "NY";
    /** Odia (Oriya) */
    SupportedLanguage["OR"] = "OR";
    /** Oromo */
    SupportedLanguage["OM"] = "OM";
    /** Pashto */
    SupportedLanguage["PS"] = "PS";
    /** Persian */
    SupportedLanguage["FA"] = "FA";
    /** Polish */
    SupportedLanguage["PL"] = "PL";
    /** Portuguese (Portugal, Brazil) */
    SupportedLanguage["PT"] = "PT";
    /** Punjabi */
    SupportedLanguage["PA"] = "PA";
    /** Quechua */
    SupportedLanguage["QU"] = "QU";
    /** Romanian */
    SupportedLanguage["RO"] = "RO";
    /** Russian */
    SupportedLanguage["RU"] = "RU";
    /** Samoan */
    SupportedLanguage["SM"] = "SM";
    /** Sanskrit */
    SupportedLanguage["SA"] = "SA";
    /** Scots Gaelic */
    SupportedLanguage["GD"] = "GD";
    /** Sepedi */
    SupportedLanguage["NSO"] = "NSO";
    /** Serbian */
    SupportedLanguage["SR"] = "SR";
    /** Sesotho */
    SupportedLanguage["ST"] = "ST";
    /** Shona */
    SupportedLanguage["SN"] = "SN";
    /** Sindhi */
    SupportedLanguage["SD"] = "SD";
    /** Sinhala (Sinhalese) */
    SupportedLanguage["SI"] = "SI";
    /** Slovak */
    SupportedLanguage["SK"] = "SK";
    /** Slovenian */
    SupportedLanguage["SL"] = "SL";
    /** Somali */
    SupportedLanguage["SO"] = "SO";
    /** Spanish */
    SupportedLanguage["ES"] = "ES";
    /** Sundanese */
    SupportedLanguage["SU"] = "SU";
    /** Swahili */
    SupportedLanguage["SW"] = "SW";
    /** Swedish */
    SupportedLanguage["SV"] = "SV";
    /** Tagalog (Filipino) */
    SupportedLanguage["TL"] = "TL";
    /** Tajik */
    SupportedLanguage["TG"] = "TG";
    /** Tamil */
    SupportedLanguage["TA"] = "TA";
    /** Tatar */
    SupportedLanguage["TT"] = "TT";
    /** Telugu */
    SupportedLanguage["TE"] = "TE";
    /** Thai */
    SupportedLanguage["TH"] = "TH";
    /** Tigrinya */
    SupportedLanguage["TI"] = "TI";
    /** Tsonga */
    SupportedLanguage["TS"] = "TS";
    /** Turkish */
    SupportedLanguage["TR"] = "TR";
    /** Turkmen */
    SupportedLanguage["TK"] = "TK";
    /** Twi (Akan) */
    SupportedLanguage["AK"] = "AK";
    /** Ukrainian */
    SupportedLanguage["UK"] = "UK";
    /** Urdu */
    SupportedLanguage["UR"] = "UR";
    /** Uyghur */
    SupportedLanguage["UG"] = "UG";
    /** Uzbek */
    SupportedLanguage["UZ"] = "UZ";
    /** Vietnamese */
    SupportedLanguage["VI"] = "VI";
    /** Welsh */
    SupportedLanguage["CY"] = "CY";
    /** Xhosa */
    SupportedLanguage["XH"] = "XH";
    /** Yiddish */
    SupportedLanguage["YI"] = "YI";
    /** Yoruba */
    SupportedLanguage["YO"] = "YO";
    /** Zulu */
    SupportedLanguage["ZU"] = "ZU";
})(SupportedLanguage || (SupportedLanguage = {}));
const _bulkMachineTranslateRequest = {
    contentToTranslate: '_translatableContent',
};
const _bulkMachineTranslateResponse = { results: '_bulkTranslateResult' };
const _bulkTranslateResult = { item: '_translatableContent' };
const _machineTranslateRequest = { contentToTranslate: '_translatableContent' };
const _machineTranslateResponse = { translatedContent: '_translatableContent' };
const _node = { nodes: '_node' };
const _richContent = { nodes: '_node' };
const _translatableContent = { richContent: '_richContent' };
/**
 * Translates the text of a translatable unit of content from one supported language to another.
 *
 * The `translatedContent` object returns with the same `id` used for `contentToTranslate.id` but the text within the
 * content fields is replaced with the translated text. Note that Wix does not overwrite the original content object.
 * To retrieve the translated content later, make sure to store it separately.
 *
 * Only text content is translated, even if the content is `htmlContent` or `richContent`. Note that [collapsible text](https://support.wix.com/en/article/adding-and-setting-up-collapsible-text)
 * cannot be translated using this method.
 *
 * The translatable content must not exceed 5,000 characters. If this limit is exceeded, the method returns a `TEXT_TOO_LONG` error.
 * For `richContent`, the 5,000-character limit applies separately to each node in `richContent.nodes`.
 * The total translatable content may be more than 5,000 characters as long as no individual node surpasses this limit.
 * If any node exceeds 5,000 characters, the entire request fails.
 *
 * Each site has a [word credit](/machine-translation/introduction#terminology) balance, starting at 3,000 words.
 * Each successful translation request reduces the word credits by the number of words in `contentToTranslate`.
 * If the site does not have sufficient word credits to translate all of the text in the request, the request fails
 * with a `NOT_ENOUGH_CREDITS` error. Additional credits can be [purchased through the Dashboard](https://support.wix.com/en/article/wix-multilingual-auto-translating-your-site?tabs=Dashboard-5#purchasing-translation-packages).
 *
 * To translate up to 1,000 `translatableContent` units at once, use [Bulk Machine Translate](/machine-translation/bulk-machine-translate).
 * @param sourceLanguage - Language of the source text to translate.
 * @public
 * @documentationMaturity preview
 * @requiredField options
 * @requiredField options.contentToTranslate
 * @requiredField options.targetLanguage
 * @requiredField sourceLanguage
 */
export function machineTranslate(sourceLanguage, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            sourceLanguage: '$[0]',
            targetLanguage: '$[1].targetLanguage',
            contentToTranslate: '$[1].contentToTranslate',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _machineTranslateRequest,
            depSchemas: { _node, _richContent, _translatableContent },
            fqdnTransformation: {
                paths: [...['contentToTranslate']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _machineTranslateResponse,
            depSchemas: { _node, _richContent, _translatableContent },
            fqdnTransformation: {
                paths: [...['translatedContent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([sourceLanguage, options]);
        const reqOpts = ambassadorWixMultilingualMachineV3TranslatableContent.machineTranslate(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'sourceLanguage',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Translates the text of multiple units of translatable content from one supported language to another.
 *
 * Each translated content item in the `results` array returns with the same `id` as the corresponding `contentToTranslate.id`, but with the text in the
 * content fields replaced with the translated text. Note that Wix does not overwrite the original content source,
 * to retrieve the translated content later, make sure to store it separately.
 *
 * Only text content is translated, even if the content is `htmlContent` or `richContent`. Note that [collapsible text](https://support.wix.com/en/article/adding-and-setting-up-collapsible-text)
 * cannot be translated using this method.
 *
 * Each unit of translatable content must not exceed 5,000 characters. If this limit is exceeded, the method returns a `TEXT_TOO_LONG` error.
 * For `richContent`, the 5,000-character limit applies separately to each node in `richContent.nodes`.
 * The total request may exceed 5,000 characters as long as no individual node surpasses this limit.
 * If any node exceeds 5,000 characters, then the request fails for that specific `contentToTranslate` item and the error details for that
 * error are returned in `itemMetadata`. Even if some translations fail due to the character limit,
 * the machine translation for other items will succeed if they are under the character limit.
 *
 * Each site has a [word credit](/machine-translation/introduction#terminology) balance, starting at 3,000 words.
 * Each successful translation request reduces the word credits by the number of words included in `contentToTranslate`.
 * If the site does not have sufficient word credits to complete the translation, then the entire request fails
 * with a `NOT_ENOUGH_CREDITS` error. Additional credits can be [purchased through the Dashboard](https://support.wix.com/en/article/wix-multilingual-auto-translating-your-site?tabs=Dashboard-5#purchasing-translation-packages).
 *
 * To translate a single unit of `translatableContent`, use [Machine Translate](/machine-translation/machine-translate).
 * @param sourceLanguage - Language of the source text to translate.
 * @public
 * @documentationMaturity preview
 * @requiredField options.targetLanguage
 * @requiredField sourceLanguage
 */
export function bulkMachineTranslate(sourceLanguage, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            sourceLanguage: '$[0]',
            targetLanguage: '$[1].targetLanguage',
            contentToTranslate: '$[1].contentToTranslate',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkMachineTranslateRequest,
            depSchemas: { _node, _richContent, _translatableContent },
            fqdnTransformation: {
                paths: [...['Array#contentToTranslate']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkMachineTranslateResponse,
            depSchemas: {
                _bulkTranslateResult,
                _node,
                _richContent,
                _translatableContent,
            },
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([sourceLanguage, options]);
        const reqOpts = ambassadorWixMultilingualMachineV3TranslatableContent.bulkMachineTranslate(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'sourceLanguage',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=multilingual-machine-v3-translatable-content.universal.js.map